var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnableAnimations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1380_5160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4456 3.875C14.5805 4.00976 14.6562 4.19255 14.6562 4.38316V16.8125C14.6562 17.0031 14.5806 17.186 14.4457 17.3207C14.3109 17.4555 14.1282 17.5313 13.9375 17.5313H1.71875C1.52813 17.5313 1.34531 17.4555 1.21052 17.3207C1.07573 17.186 1 17.0031 1 16.8125V1.71875C1 1.52812 1.07573 1.34531 1.21052 1.21051C1.34531 1.07572 1.52813 1 1.71875 1H11.2731C11.4637 1.00004 11.6465 1.07579 11.7813 1.2106L14.4456 3.875Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.38059 6.48121C6.27116 6.42037 6.14775 6.38916 6.02257 6.39068C5.8974 6.39219 5.77478 6.42637 5.66687 6.48983C5.55896 6.5533 5.4695 6.64386 5.40735 6.75252C5.34519 6.86119 5.3125 6.98421 5.3125 7.1094V12.5C5.3125 12.6252 5.34519 12.7482 5.40735 12.8569C5.4695 12.9656 5.55896 13.0562 5.66687 13.1196C5.77478 13.1831 5.8974 13.2173 6.02257 13.2188C6.14775 13.2203 6.27116 13.1891 6.38059 13.1282L11.0524 10.2532C11.1645 10.1909 11.2578 10.0999 11.3227 9.98941C11.3877 9.87901 11.4219 9.75316 11.4219 9.62506C11.4219 9.49688 11.3877 9.37111 11.3227 9.26063C11.2578 9.15016 11.1645 9.05911 11.0524 8.99686L6.38059 6.48121Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1380_5160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnableAnimations);
export default __webpack_public_path__ + "static/media/enable_animations.de649b5465d6738dbbdf40f8e9c119e0.svg";
export { ForwardRef as ReactComponent };